import { Box, Card, Container, Grid, InputAdornment, Paper, Stack, styled,TextField, Typography } from "@mui/material";

const dialogWidth = 600;

export const MainStyledContainer = styled(Box)(() => ({
    height: 570,
    width: dialogWidth,
    padding: 15
}));

export const FormTitleTypography = styled(Typography)(() => ({
  marginBottom: 20
}));

export const ImageBox = styled(Box)(() => ({
  paddingTop: 5,
  paddingLeft: 10,
  width: 32,
  height: 32
}));

export const SearchTitleTypography = styled(Typography)(() => ({
  width: "100%",
  marginLeft: 10,
  marginTop: 12,
  fontStyle: "italic",
  paddingRight: 10 
}));


export const HeaderGrid = styled(Grid)(() => ({
  //background: 'linear-gradient(#e66465, #9198e5);'
}));

export const ScrollingStyledContainer = styled(Container)(() => ({
    width: dialogWidth-25,
    height: 325,
    overflowX: "auto"
}));

export const BankInstitutionPaper = styled(Paper)(({ theme }) => ({
  cursor: "pointer",
  marginTop: "5px",
  height: "40px",
  marginBottom:"5px"
}));



export const ButtonBox = styled(Stack)(({ theme }) => ({
    justifyContent: "flex-end",
    alignContent: "flex-end",
    marginRight: 2,
    marginBottom: -200
}));

export const SearchBarInput = styled(TextField)`
  padding-bottom: 15px;
  fieldset {
    border-radius: 50px;
    border: 1px solid #919195;
  }

  input {
    width: 100%;
    padding-right: 10px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    padding-left: 0px !important;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid #919195;
  }
`;

export const SearchInputAdornment = styled(InputAdornment)`
  padding-left: 10px;
`;